{
  "connect": "Connect",
  "mode": "Mode",
  "viewOnly": "View only",
  "loadingSettings": "Loading the settings…",
  "probeServer": "Probe the server",
  "notProbedYet": "The server has not been probed yet — the platform does it on the first connection.",
  "serverNotIdentified": "server not identified",
  "hasFileTransfer": ", file transfer available",
  "probedAt": "probed {{at}}",
  "serverInfo": "Server details",
  "noOpenSessions": "No open sessions",
  "noOpenSessionsHint": "A connection starts from the network map or the node list: pick a node and press “Connect”. One machine gets one tab.",
  "closeTab": "Close the {{name}} tab",
  "serverKind": {
    "auto": "Detect automatically",
    "tightvnc": "TightVNC",
    "ultravnc": "UltraVNC",
    "tigervnc": "TigerVNC",
    "realvnc": "RealVNC",
    "x11vnc": "x11vnc",
    "other": "Other"
  },
  "encoding": "Encoding",
  "securityType": {
    "none": "no authentication",
    "vncAuth": "VNC Authentication",
    "ra2": "RSA-AES (RA2)",
    "ra2ne": "RSA-AES without encryption (RA2ne)",
    "tight": "Tight",
    "ultra": "UltraVNC",
    "realvnc": "RealVNC proprietary authentication",
    "vencrypt": "VeNCrypt",
    "appleArd": "Apple Screen Sharing",
    "numbered": "type {{type}}"
  },
  "serverKindUnknown": "could not be determined",
  "info": {
    "server": "Server",
    "unknownKind": "could not be determined",
    "rfbVersion": "RFB version",
    "desktop": "Desktop",
    "desktopHint": "The only thing the server states about itself as a string: RFB has no version field of its own",
    "route": "Route",
    "viaAgent": "through the site agent",
    "direct": "directly",
    "encoding": "Encoding",
    "encodingHint": "The first in the list offered to the server. RFB does not report which one it chose",
    "securityTypes": "Login types",
    "capabilities": "Capabilities",
    "clipboard": "clipboard",
    "fileTransfer": "file transfer",
    "viewOnly": "view only",
    "screenAndInputOnly": "screen and input only"
  },
  "scaling": {
    "fit": "Fit",
    "native": "1:1",
    "remote": "Match the window",
    "remoteUnavailable": "This server cannot change the desktop resolution at a client's request"
  },
  "combo": {
    "altTab": "Switch windows on the remote machine",
    "altF4": "Close a window on the remote machine",
    "taskManager": "Windows Task Manager",
    "explorer": "File Explorer",
    "run": "The Run dialog",
    "lock": "Lock the remote machine"
  },
  "toolbar": {
    "viewOnlyLocked": "Set in the node properties: input does not reach the machine and the button cannot enable it",
    "takeControl": "Take control",
    "viewOnlyHint": "Watch without touching: the browser stops sending keys and mouse",
    "viewOnlyOn": "View-only mode is on",
    "sendCad": "Send Ctrl+Alt+Del",
    "combos": "Key combos",
    "clipboard": "Clipboard",
    "pasteDisabled": "Pasting to the machine is unavailable in view-only mode",
    "fromMachine": "From the machine",
    "toMachine": "To the machine",
    "nothingCopied": "The machine copied nothing during this session",
    "pastePlaceholder": "Text to paste on the remote machine",
    "send": "Send",
    "files": "Files",
    "filesHint": "Remote machine files over the screen",
    "quality": "Quality",
    "qualityAria": "Image quality",
    "compression": "Compression",
    "compressionAria": "Compression level",
    "latencyHint": "Latency to the machine",
    "noLatency": "— ms",
    "bytesHint": "Received this session",
    "fullscreen": "Full screen",
    "disconnect": "Disconnect"
  },
  "screen": {
    "connecting": "Connecting to the machine…",
    "requestingTicket": "Requesting permission to connect",
    "closed": "The session is closed",
    "failed": "Could not connect",
    "finished": "The connection to the machine has ended",
    "closedByPeer": "The connection was closed",
    "lost": "The connection to the machine was lost",
    "openFailed": "Could not open the session",
    "viewOnlyByNode": "View only — the node is configured this way, input does not reach the machine",
    "viewOnlyOnPhone": "View only — a desktop is not driven from a phone",
    "viewOnlyByToolbar": "View only — sessions open this way; take control with the toolbar button",
    "hideInfo": "Hide the details",
    "info": "Details",
    "reconnect": "Connect again"
  },
  "hint": {
    "ticketInvalid": "The ticket is single-use and lives thirty seconds. Press “Connect again”.",
    "noCredential": "Attach a VNC credential to the node in its properties.",
    "authFailed": "Check the password in the credential. A VNC password longer than eight characters is truncated by the server.",
    "portClosed": "Check whether the VNC server is running on the machine and whether the node properties name the right port.",
    "securityUnsupported": "The platform does not support this login method. Configure VNC Authentication on the server.",
    "sessionLimit": "Close one of the open tabs and try again.",
    "permissionDenied": "The `vnc:connect` permission comes from a role or is granted per node. Ask your organization administrator.",
    "agentOffline": "The site agent is not connected. Check the netdeck-agent service."
  },
  "server": "Server",
  "tabsCount": "{{open}} of {{max}}"
}
